export const servicesData = [
  {
    id: 1,
    title: 'Transporte Empresarial',
    description: 'Soluciones de movilidad personalizadas para ejecutivos y colaboradores. Flota de autobuses ejecutivos con amenidades premium, aire acondicionado y conectividad a bordo.',
    icon: 'ri-building-2-line',
    features: ['Autobuses ejecutivos', 'Aire acondicionado', 'WiFi a bordo', 'GPS en tiempo real'],
  },
  {
    id: 2,
    title: 'Transporte de Personal Industrial',
    description: 'Movilidad segura y eficiente para plantas manufactureras y centros de distribución. Cumplimiento con normativas de seguridad industrial y puntualidad garantizada.',
    icon: 'ri-building-4-line',
    features: ['Normativas de seguridad', 'Puntualidad garantizada', 'Rutas optimizadas', 'Reportes diarios'],
  },
  {
    id: 3,
    title: 'Turismo y Renta de Unidades',
    description: 'Autobuses y camionetas modernas para viajes de turismo, eventos corporativos y traslados especiales. Conductor capacitado y vehículos de lujo.',
    icon: 'ri-road-map-line',
    features: ['Camionetas ejecutivas', 'Autobuses de lujo', 'Conductores certificados', 'Servicio turístico'],
  },
  {
    id: 4,
    title: 'Rutas Especiales',
    description: 'Diseño de rutas personalizadas según las necesidades específicas de cada cliente. Análisis de tráfico y optimización de tiempos de traslado.',
    icon: 'ri-route-line',
    features: ['Rutas a medida', 'Análisis de tráfico', 'Optimización de tiempos', 'Flexibilidad horaria'],
  },
  {
    id: 5,
    title: 'Servicios Nocturnos',
    description: 'Transporte seguro durante turnos nocturnos y madrugada. Iluminación interior, protocolos de seguridad nocturna y monitoreo constante.',
    icon: 'ri-moon-line',
    features: ['Seguridad nocturna', 'Iluminación interior', 'Monitoreo 24/7', 'Protocolos especiales'],
  },
  {
    id: 6,
    title: 'Turnos Mixtos',
    description: 'Soluciones adaptadas a empresas con múltiples turnos de trabajo. Coordinación eficiente entre diferentes horarios de entrada y salida.',
    icon: 'ri-time-line',
    features: ['Múltiples turnos', 'Coordinación eficiente', 'Flexibilidad total', 'Cobertura completa'],
  },
];

export const statsData = [
  { number: '20+', label: 'Años de experiencia operativa' },
  { number: '2', label: 'Ciudades de cobertura directa' },
  { number: '100%', label: 'Compromiso de puntualidad' },
];

export const coverageData = [
  {
    city: 'San Luis Potosí',
    description: 'Cobertura completa en toda la zona metropolitana y áreas industriales de San Luis Potosí.',
    routes: ['Zona Industrial', 'Centro Histórico', 'Aeropuerto', 'Parques Industriales'],
    coordinates: { lat: 22.1565, lng: -100.9855 },
  },
  {
    city: 'Monterrey',
    description: 'Servicio empresarial en la zona metropolitana de Monterrey y sus principales centros industriales.',
    routes: ['Parque Industrial', 'Santa Catarina', 'Apodaca', 'Escobedo'],
    coordinates: { lat: 25.6866, lng: -100.3161 },
  },
];

export const testimonialsData = [
  {
    id: 1,
    name: 'Ing. Roberto Méndez',
    role: 'Gerente de Operaciones',
    company: 'Grupo Industrial del Centro',
    text: 'Hace 5 años que trabajamos con Yakis y la puntualidad ha mejorado un 40%. Su flota moderna y el profesionalismo del personal son inigualables en la región.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
  },
  {
    id: 2,
    name: 'Dra. María González',
    role: 'Directora de RRHH',
    company: 'Manufacturas del Norte',
    text: 'El servicio nocturno de Yakis ha sido fundamental para nuestra planta de Monterrey. La seguridad que brindan a nuestro personal es invaluable.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face',
  },
  {
    id: 3,
    name: 'Lic. Carlos Ramírez',
    role: 'CEO',
    company: 'Logística Premium S.A.',
    text: 'La modernización de su flota refleja exactamente lo que buscábamos: un partner tecnológico, no solo un transportista. Recomendados al 100%.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face',
  },
];

export const galleryData = [
  {
    id: 1,
    src: 'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/bf393f39fd11d61c12d49c8ecf57a9aa.png',
    alt: 'Autobús ejecutivo Yakis - Flota moderna',
    category: 'Flota',
  },
  {
    id: 2,
    src: 'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/158688de5b3bbabc377ee316404538d8.png',
    alt: 'Interior premium de autobús ejecutivo',
    category: 'Interior',
  },
  {
    id: 3,
    src: 'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/04a55f8cbc0c28f64813c46bf579cc4e.png',
    alt: 'Camioneta ejecutiva para transporte empresarial',
    category: 'Flota',
  },
  {
    id: 4,
    src: 'https://readdy.ai/api/search-image?query=San%20Luis%20Potosi%20Mexico%20industrial%20zone%20aerial%20view%20modern%20manufacturing%20area%20clean%20professional%20landscape&width=800&height=500&seq=4&orientation=landscape',
    alt: 'Zona industrial de San Luis Potosí',
    category: 'Cobertura',
  },
  {
    id: 5,
    src: 'https://readdy.ai/api/search-image?query=Monterrey%20Mexico%20industrial%20corporate%20buildings%20modern%20cityscape%20professional%20landscape%20urban&width=800&height=500&seq=5&orientation=landscape',
    alt: 'Área metropolitana de Monterrey',
    category: 'Cobertura',
  },
  {
    id: 6,
    src: 'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/f5d254171c77f9bb835350ed55bc0e96.png',
    alt: 'Flota completa de autobuses Yakis',
    category: 'Flota',
  },
];

export const advantagesData = [
  {
    id: 1,
    title: 'Flota Moderna',
    description: 'Vehículos 2022-2024 con tecnología GPS, monitoreo en tiempo real y sistemas de seguridad avanzada.',
    icon: 'ri-bus-2-line',
  },
  {
    id: 2,
    title: 'Conductores Certificados',
    description: 'Personal altamente capacitado con certificaciones en manejo defensivo y atención al cliente empresarial.',
    icon: 'ri-shield-user-line',
  },
  {
    id: 3,
    title: 'Puntualidad Garantizada',
    description: 'Sistema de rastreo en tiempo real que permite cumplimiento estricto de horarios y reportes automáticos.',
    icon: 'ri-time-line',
  },
  {
    id: 4,
    title: 'Seguridad Total',
    description: 'Protocolos de seguridad industrial, seguros de cobertura amplia y mantenimiento preventivo continuo.',
    icon: 'ri-shield-check-line',
  },
  {
    id: 5,
    title: 'Atención 24/7',
    description: 'Centro de control operativo activo las 24 horas para atención de emergencias y coordinación inmediata.',
    icon: 'ri-customer-service-2-line',
  },
  {
    id: 6,
    title: 'Cobertura Binacional',
    description: 'Presencia directa en San Luis Potosí y Monterrey, con capacidad de expansión a otras ciudades del país.',
    icon: 'ri-map-pin-2-line',
  },
];